export default {"src":"/_next/static/media/Obesity and Overweight.76db565a.svg","height":52,"width":42,"blurWidth":0,"blurHeight":0};